var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.031 16.37A33.518 33.518 0 0 0 34.7 31.87a1.5 1.5 0 0 0 2.526 1.619 30.63 30.63 0 1 1 .4 33.636 1.5 1.5 0 1 0-2.48 1.675 33.632 33.632 0 1 0 27.885-52.43ZM26.686 31.182h-7a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3ZM12.26 42.841h9.477a1.5 1.5 0 1 0 0-3H12.26a1.5 1.5 0 1 0 0 3ZM19.526 50a1.5 1.5 0 0 0-1.5-1.5H4.838a1.5 1.5 0 0 0 0 3h13.188a1.5 1.5 0 0 0 1.5-1.5Zm3.711 8.659a1.5 1.5 0 0 0-1.5-1.5H12.26a1.5 1.5 0 1 0 0 3h9.477a1.5 1.5 0 0 0 1.5-1.5Zm3.449 7.159h-7a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.194 60.851a1.5 1.5 0 0 0 2.121 2.121l11.912-11.911a1.5 1.5 0 0 0 0-2.122L67.315 37.028a1.5 1.5 0 0 0-2.121 2.121l9.351 9.351H30.9a1.5 1.5 0 1 0 0 3h43.645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.4c766e32ac4fdf5dab7b944c43d1c85a.svg";
export { ForwardRef as ReactComponent };